import type { IconProps } from "@/components/icons/types";

export function WalletIcon({ size = 24, className = "", ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M3 7h15a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7z" />
      <path d="M3 7V6a2 2 0 0 1 2-2h11v3" />
      <circle cx="17" cy="13.5" r="1" />
    </svg>
  );
}
